import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TimelineCheckpointIcon from "./TimelineCheckpointIcon";
import TriangleSvg from "./TriangleSvg";
import React from "react";
import { useTranslation } from "react-i18next";

const OurStory = ({ headerText, children }) => {
  const { t } = useTranslation();

  const timelineCheckpoints = [
    {
      header: t("landing.aboutUs.timeline.idea.header"),
      text: t("landing.aboutUs.timeline.idea.text"),
      year: "2008",
      rightGradientColor: "#FE5F00",
      leftGradientColor: "#E22D94",
    },
    {
      header: t("landing.aboutUs.timeline.scientific.header"),
      text: t("landing.aboutUs.timeline.scientific.text"),
      year: "2010",
      rightGradientColor: "#FBC405",
      leftGradientColor: "#FF7A01",
    },
    {
      header: t("landing.aboutUs.timeline.doctorate.header"),
      text: t("landing.aboutUs.timeline.doctorate.text"),
      year: "2014",
      rightGradientColor: "#00B98D",
      leftGradientColor: "#00BAC3",
    },
    {
      header: t("landing.aboutUs.timeline.firstProjects.header"),
      text: t("landing.aboutUs.timeline.firstProjects.text"),
      year: "2017",
      rightGradientColor: "#00A1AC",
      leftGradientColor: "#21679E",
    },
    {
      header: t("landing.aboutUs.timeline.software.header"),
      text: t("landing.aboutUs.timeline.software.text"),
      year: "2022",
      rightGradientColor: "#F309EF",
      leftGradientColor: "#8A4FDD",
    },
    {
      header: t("landing.aboutUs.timeline.startup.header"),
      text: t("landing.aboutUs.timeline.startup.text"),
      year: "2024",
      rightGradientColor: "#AE090C",
      leftGradientColor: "#D62F64",
    },
  ];
  return (
    <div>
      <div>
        <Row className={"justify-content-center mx-0"} style={{ padding: "150px 0" }}>
          <Col xs={11} lg={5} className={"text-12 text-lg-20 align-content-center pb-4"}>
            {headerText && (
              <Row
                className={"mx-lg-2 mb-4 EB-Garamond fw-medium text-36 text-lg-56 text-color-primary lh-1"}
                style={{ letterSpacing: "-1px" }}
              >
                <Col>{headerText}</Col>
              </Row>
            )}

            <Row className={"mx-lg-2"}>
              <Col style={{ color: "#626C77" }}>{children}</Col>
            </Row>
          </Col>
          <Col lg={6} xs={11}>
            <Row>
              <Col
                className={"px-0 position-relative d-none d-md-block z-0"}
                xs={"auto"}
                style={{ borderRight: "solid 4px #081F43" }}
              >
                <div className={"position-absolute  "} style={{ top: -20, left: -8 }}>
                  <TriangleSvg></TriangleSvg>
                </div>
                <div
                  className={"position-absolute rotate-180 "}
                  style={{
                    bottom: -20,
                    left: -8,
                    transform: " rotate(180deg)",
                  }}
                >
                  <TriangleSvg></TriangleSvg>
                </div>
              </Col>
              <Col
                className={"px-0 position-relative z-1 fw-semibold"}
                style={{
                  color: "#081F43",
                }}
              >
                {timelineCheckpoints.map((checkpoint, i) => {
                  return (
                    <Row className={"py-4"} key={i}>
                      <Col xs={"auto"} className={"ms-5 ms-md-0"}>
                        <TimelineCheckpointIcon
                          index={i}
                          label={checkpoint.year}
                          leftGradientColor={checkpoint.leftGradientColor}
                          rightGradientColor={checkpoint.rightGradientColor}
                        ></TimelineCheckpointIcon>
                      </Col>
                      <Col className={"align-content-center mt-3 mt-md-0 "} xs={12} md={true}>
                        <div className={"text-lg-32 text-sm-26 text-22"}>{checkpoint.header}</div>
                        <div className={"text-lg-24 text-sm-20 text-16 "}>{checkpoint.text}</div>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default OurStory;
